import "./App.css";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { BrowserRouter as Router } from "react-router-dom";
import { Suspense } from "react";
import AppRoutes from "./AppRoutes";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "toastr/build/toastr.min.css";
import { SocketProvider } from "./SocketContext";
import { useDarkMode } from "./contexts/DarkModeContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

function Loading({ darkMode }) {
  return (
    <div
      style={{
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: darkMode ? "#333" : "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Navbar Skeleton */}
      <div
        style={{
          width: "100%",
          height: "60px",
          display: "flex",
          alignItems: "center",
          padding: "0 20px",
          backgroundColor: darkMode ? "#444" : "#f0f0f0",
        }}
      >
        <Skeleton
          circle
          width={40}
          height={40}
          style={{ marginRight: "20px" }}
        />
        <Skeleton height={30} width="20%" />
        <div style={{ marginLeft: "auto", display: "flex", gap: "15px" }}>
          <Skeleton circle width={40} height={40} />
          <Skeleton circle width={40} height={40} />
        </div>
      </div>

      {/* Layout Wrapper */}
      <div style={{ display: "flex", flexGrow: 1, width: "100%" }}>
        {/* Sidebar Skeleton */}
        <div
          style={{
            width: "250px",
            backgroundColor: darkMode ? "#444" : "#f0f0f0",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          {Array(8)
            .fill(0)
            .map((_, index) => (
              <div
                key={index}
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <Skeleton circle width={30} height={30} />
                <Skeleton height={20} width="70%" />
              </div>
            ))}
        </div>

        {/* Content Skeleton */}
        <div
          style={{
            flexGrow: 1,
            padding: "20px",
            backgroundColor: darkMode ? "#333" : "#fff",
          }}
        >
          {/* Header Section */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <Skeleton height={40} width="40%" />
            <Skeleton height={40} width="30%" />
          </div>

          {/* Main Content Area */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "20px",
            }}
          >
            {Array(6)
              .fill(0)
              .map((_, index) => (
                <div key={index}>
                  <Skeleton height={150} width="100%" />
                  <Skeleton
                    height={20}
                    width="80%"
                    style={{ marginTop: "10px" }}
                  />
                  <Skeleton height={20} width="60%" />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function App() {
  const { darkMode } = useDarkMode();
  const User = JSON.parse(sessionStorage.getItem("data"))?.User;
  const userId = User?._id || null;
  const stripePromise = loadStripe(
    "pk_test_51Nslp2ALrZwtYjxI2NX9MEQC5Hf6GAiR4Wi99w9BBWKDhinAmEqBrE8gmtvzbgGoVbOdKaabeUlBuY2Z0IoUzv7u00xYWHLZbi"
  );

  return (
    <Elements stripe={stripePromise}>
      <SidebarProvider>
        <SocketProvider userId={userId}>
          <Provider store={store} className="App">
            <Router>
              <Suspense fallback={<Loading darkMode={darkMode} />}>
                <AppRoutes />
              </Suspense>
            </Router>
          </Provider>
        </SocketProvider>
      </SidebarProvider>
    </Elements>
  );
}

export default App;
